/* eslint-disable react/jsx-no-target-blank */
import { metadataH2 } from "app/brands/components/BrandMetadataPanel"
import { optionalRender } from "app/common/ui/optionalRender"
import { BrandVM } from "app/models"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import useTranslation from "next-translate/useTranslation"
import React, { FC } from "react"
import { BiBuilding, BiBuildings } from "react-icons/bi"
import { BiListUl } from "react-icons/bi"
import { tw } from "twind"

interface WhereToBuyProps {
  brand: BrandVM
}

export const WhereToBuy: FC<WhereToBuyProps> = ({ brand }) => {
  const { t } = useTranslation("brands")

  return (
    <div>
      <h2 className={tw(metadataH2, `px-1`)}>{t("where-to-buy")}</h2>
      <div className={tw(`flex(& col) gap-2`)}>
        {brand.isEcommerceEnabled &&
          pipe(
            brand.url,
            optionalRender((url) => (
              <div className={tw(`flex gap-2`, `text-sm`)}>
                <BiBuilding className={tw(`text-xl`)} />
                <a className={tw("blogLink", "text-sm")} href={url} rel="noopener" target="_blank">
                  {t("buy-directly-from")} {brand.name}
                </a>
              </div>
            ))
          )}

        {pipe(
          brand.stockistsUrl,
          optionalRender((url) => (
            <div className={tw(`flex gap-2`, `text-sm`)}>
              <BiListUl className={tw(`text-xl`)} />
              <a className={tw("blogLink", "text-sm")} href={url} rel="noopener" target="_blank">
                {t("view-brand-retailer-list", { brand: brand.name })}
              </a>
            </div>
          ))
        )}

        {pipe(
          brand.stockists,
          array.map((stockist) => (
            <li key={stockist.url}>
              <a
                className={tw("blogLink", "text-sm")}
                href={stockist.url}
                rel="noopener"
                target="_blank"
              >
                {stockist.name}
              </a>
            </li>
          )),
          (as) =>
            array.isNonEmpty(as) && (
              <div className={tw(`flex gap-2`, `text-sm`)}>
                <BiBuildings className={tw(`text-xl`)} />

                <div className={tw(`flex(& col) gap-1`)}>
                  <div className={tw(`font-semibold`)}>{t("buy-from-canadian-retailers")}</div>
                  <ul className={tw(`flex(& col) gap-1`)}>{as}</ul>
                </div>
              </div>
            )
        )}
      </div>
    </div>
  )
}
